
import React from "react";
import "./index.scss";

const DataNotFound = () => {
  return (
    <section className="data-not-found">
      <h1>Data Not Found</h1>
      <p>Sorry, the data you are looking for could not be found.</p>
    </section>
  );
};

export default DataNotFound;
